export const AUTH_MODE = {
  PHONE: 'PHONE',
  EMAIL_LINK: 'EMAIL_LINK',
  EMAIL: 'EMAIL',
  EMAIL_PASSWORD: 'EMAIL_PASSWORD',
  EMAIL_PIN: 'EMAIL_PIN',
};

export const CONTENT_PANE = {
  LOGIN_FORM: 'LOGIN_FORM',
  EMAIL_INSTRUCTIONS: 'EMAIL_INSTRUCTIONS',
};

export const USER_MODE = {
  SHUTTERBUG: 'SHUTTERBUG',
  PRO: 'PRO',
};
